import { render, staticRenderFns } from "./commentMarche.vue?vue&type=template&id=a2487c56&scoped=true"
import script from "./commentMarche.vue?vue&type=script&lang=js"
export * from "./commentMarche.vue?vue&type=script&lang=js"
import style0 from "./commentMarche.vue?vue&type=style&index=0&id=a2487c56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2487c56",
  null
  
)

export default component.exports